import { useEffect } from 'react';
import NProgress from 'nprogress';
// next
import { useRouter } from 'next/router';

// Estilos globais para NProgress, usando tokens CSS. Sao injetados como <style>
// porque NProgress cria DOM fora da React tree. A cor primaria vem de --gps-accent
// que ja responde a tema claro/escuro. O zIndex e fixo porque nao e controlado
// por Tailwind/tema neste contexto especifico (barra de progresso deve estar
// sempre acima, como snackbar do MUI).

export default function ProgressBar() {
  const router = useRouter();

  NProgress.configure({ showSpinner: false });

  useEffect(() => {
    const handleStart = () => {
      NProgress.start();
    };
    const handleStop = () => {
      NProgress.done();
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);

  return (
    <style>{`
      #nprogress {
        pointer-events: none;
      }
      #nprogress .bar {
        top: 0;
        left: 0;
        height: 2px;
        width: 100%;
        position: fixed;
        z-index: 1300;
        background-color: var(--gps-accent);
        box-shadow: 0 0 2px var(--gps-accent);
      }
      #nprogress .peg {
        right: 0;
        opacity: 1;
        width: 100px;
        height: 100%;
        display: block;
        position: absolute;
        transform: rotate(3deg) translate(0px, -4px);
        box-shadow: 0 0 10px var(--gps-accent), 0 0 5px var(--gps-accent);
      }
    `}</style>
  );
}
